export const TARGET_FORGOT_PASSWORD = 'targetForgotPassword'
export const TARGET_RESET_PASSWORD = 'targetResetPassword'
